import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { Carousel } from 'react-responsive-carousel'
import BreadcrumbComponent from '../../components/ProductScreenComponents/Breadcrumb'
import { useStylesProducts } from '../../components/ProductsSection/styles'
import { useStyles } from './ProductPage.styles'
import { formatNumber } from '../../utils/formatNumber'
import {
  Grid,
  Button,
  Divider,
  Typography,
  Box,
  useMediaQuery,
  CardMedia,
  TextField,
  CircularProgress,
  Skeleton
} from '@mui/material'
import ProductsSection from '../../components/ProductsSection'
import Tabla from '../../components/Tabla'
import sinImagen from '../../assets/sinImagen.jpg'
import creditCard from '../../assets/creditCard.jpg'
import SizeComponent from '../../components/SizeComponent/SizeComponent'
import AddMinusQuantity from '../../components/AddMinusQuantity'
import {
  addItemToCart,
  removeItemFromCart,
} from 'stores/cartStore/actionsCart'
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined'
import {
  detailsProduct,
  listProducts,
} from 'stores/productStore/actionsProducts'
import MetodosDePagoModal from './MetodosDePagoModal'
import CaravanasOficiales from 'components/CaravanasCheckout/CaravanasOficiales'
import CaravanasNoOficiales from 'components/CaravanasCheckout/CaravanasNoOficiales'
import {
  getColorsFromAttributes,
  getSizesFromAttributes,
} from './utils/getAttributes'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import FavoriteIcon from '@mui/icons-material/Favorite'
import { setSnackbar } from 'stores/snackbarStore'
import ConsultarProducto from 'components/ConsultarProducto/ConsultarProducto'
import {
  selectCurrentBranch,
  updateBranchList,
} from 'stores/userStore/actionsUser'
import CaravanasCombinadas from 'components/CaravanasCheckout/CaravanasCombinadas'
import {
  noStockMessage,
  productWithCotizacionInDollars,
} from 'utils/noStockMessage'
import { getAllProductDiscount } from './utils/getProductDiscounts'
import DiscountLabel from 'components/DiscountLabel/index'
import { getProductsToAdd } from './utils/getProductsToAdd'
import { fixAmount } from './utils/helpers'
import { Helmet } from 'react-helmet'
import { debounce } from 'utils/debounce'
import NoResults from 'components/NoResults/NoResults'
import { ProductDetailsSection } from './ProductDetailsSection'



const ProductPage = () => {
  const desktop = useMediaQuery((theme) => theme.breakpoints.up('sm'), { noSsr: true })
  const products = useSelector(({ productList }) => productList)
  const { product } = useSelector(({ productDetails }) => productDetails)
  const styles = useStyles()
  const itemsToShow = desktop ? 12 : 6
  
  return (
    <>
      <Helmet>
        <title>
          {`${product?.nombreEC || product?.nombre || ''}`} | Villanueva
        </title>
        <meta
          name='description'
          content={
            product?.descripcionGeneral ||
            product?.descripcionTecnica ||
            product?.nombreEC ||
            product?.nombre ||
            ''
          }
        />
        <meta
          name='keywords'
          content={`villanueva, producto, ${
            product?.nombreEC || product?.nombre || ''
          }, ${product?.keywords || ''}`}
        />
      </Helmet>
      <Grid className={styles.container}>
        <ProductDetailsSection />
        {products?.product?.slice?.(0, itemsToShow)?.length > 0 && (
          <Box sx={{ padding: '50px 0px 67px 10px' }}>
            <ProductsSection
              titleSection='Quienes vieron este producto también compraron'
              toURL='/'
              scrollVertical={false}
              data={products.product?.slice(0, itemsToShow)}
              carouselIndex={1}
            />
            <Box sx={{ marginTop: '50px' }} />
            <ProductsSection
              titleSection='Tambien pueden interesarte'
              toURL='/'
              scrollVertical={false}
              buttonLabel='Recomendados'
              data={products.product?.slice(0, itemsToShow)}
              carouselIndex={2}
            />
          </Box>
        )}
      </Grid>
    </>
  )
}

export default ProductPage
